var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.5H21.5",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.00001C17.3978 3.60219 17.9374 3.37869 18.5 3.37869C18.7786 3.37869 19.0544 3.43356 19.3118 3.54017C19.5692 3.64677 19.803 3.80303 20 4.00001C20.197 4.197 20.3532 4.43085 20.4598 4.68822C20.5665 4.94559 20.6213 5.22144 20.6213 5.50001C20.6213 5.77859 20.5665 6.05444 20.4598 6.31181C20.3532 6.56918 20.197 6.80303 20 7.00001L7.5 19.5L3.5 20.5L4.5 16.5L17 4.00001Z",
    stroke: "#949494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.73597408d4bcd1373b57a97b3910356b.svg";
export { ForwardRef as ReactComponent };